import { t } from 'i18next';
import { object, ref, string } from 'yup';
import {
  getReviewerPasswordValidation,
  getValidationMessages,
  yup,
} from '@lon/shared/utils';
import { HandleError } from './types';

export const validationSchema = object({
  username: string()
    .trim()
    .required(
      t('validationMessages.requiredField', {
        fieldName: 'Username',
      })
    )
    .max(
      255,
      t('validationMessages.maxLength', {
        fieldName: 'Username',
        length: 255,
      })
    )
    .default(''),
  firstName: string()
    .trim()
    .required(
      t('validationMessages.requiredField', {
        fieldName: 'First Name',
      })
    )
    .max(
      255,
      t('validationMessages.maxLength', {
        fieldName: 'First Name',
        length: 255,
      })
    )
    .default(''),
  lastName: string()
    .trim()
    .required(
      t('validationMessages.requiredField', {
        fieldName: 'Last Name',
      })
    )
    .max(
      255,
      t('validationMessages.maxLength', {
        fieldName: 'Last Name',
        length: 255,
      })
    )
    .default(''),
  email: yup
    .string()
    .required(
      t('validationMessages.requiredField', {
        fieldName: 'Email',
      })
    )
    .nullable()
    .trim()
    .strongEmail()
    .default(''),
  password: getReviewerPasswordValidation(true).default(''),
  repeatedPassword: string()
    .trim()
    .required(
      t('validationMessages.requiredField', {
        fieldName: 'Confirm Password',
      })
    )
    .oneOf(
      [ref('password'), null],
      getValidationMessages().notMatchingPasswords
    )
    .default(''),
});

export const getValidation = () => ({
  validationSchema,
  defaultValues: validationSchema.cast({}),
});

export const handleError: HandleError = ({
  error,
  toast,
  username,
  t,
  i18n,
}) => {
  error?.graphQLErrors?.forEach((e: { message: string }) => {
    const [field, message] = e.message.split(': ');
    const errorMessage = `validationMessages.${field}.${message}`;

    if (i18n.exists(`${errorMessage}.title`)) {
      toast({
        title: t(`${errorMessage}.title`, { username: username }) as string,
        description: t(`${errorMessage}.description`) as string,
        isClosable: true,
        variant: 'error-light',
        duration: null,
      });
    } else {
      toast({
        title: t('validationMessages.unknown.title') as string,
        description: t('validationMessages.unknown.description') as string,
        isClosable: true,
        variant: 'error-light',
        duration: null,
      });
    }
  });
};
